import { Route, AppId, createPageRoute } from '@lumapps/router';

export const marketplaceLibraryRoute: Route = createPageRoute({
    slug: 'extensions/library',
    legacyId: 'app.admin.marketplace',
    appId: AppId.backOffice,
});
